import { render, staticRenderFns } from "./DecorView.vue?vue&type=template&id=3636fd20&scoped=true"
import script from "./DecorView.vue?vue&type=script&lang=js"
export * from "./DecorView.vue?vue&type=script&lang=js"
import style0 from "./DecorView.vue?vue&type=style&index=0&id=3636fd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636fd20",
  null
  
)

export default component.exports